import {Component, inject} from '@angular/core';
import {Router} from '@angular/router';
import {TranslationService} from '../../../core/services/translation.service';

@Component({
  selector: 'app-revocation-without-login-after',
  templateUrl: './revocation-without-login-after.component.html',
  styleUrls: ['./revocation-without-login-after.component.scss']
})
export class RevocationWithoutLoginAfterComponent {
  translationService = inject(TranslationService);

  formData: {firstName: string; lastName: string; email: string; orderNo: string} | null;

  constructor() {
    const navigation = inject(Router).getCurrentNavigation();
    this.formData = navigation?.extras?.state?.['formData'] ?? null;
  }
}
